import React, { useCallback, useEffect, useState } from "react";
import Select from "react-select";
import { useParams } from "react-router-dom";
import { Table, Button, Card, Row, Col, Dropdown, Modal, Form, Spinner } from "react-bootstrap";
import { getPresupuestoById, updateEstadoPresupuesto, updateItemPresupuesto, insertItemPresupuesto, insertCondicionesPresupuesto, deleteItemPresupuesto, deleteConPresupuesto, updateCondicionesPresupuesto, updatePresupuesto } from "../../../Api/presupuesto";
import { getAllCostos } from "../../../Api/Costos";
import { getAllCondiciones } from "../../../Api/AdminApi";
import { TailSpin } from "react-loader-spinner";
import { pdf } from "@react-pdf/renderer";
import CombinedPDF from "./CombinedPDF";
import "bootstrap/dist/css/bootstrap.min.css";
const customSelectStyles = {
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
  control: (provided) => ({
    ...provided,
    width: '100%',
  }),
};

const FichaPresupuesto = () => {
  const [pdfReady, setPdfReady] = useState(null);
  const [pdfTipo, setPdfTipo] = useState(""); // nuevo
  const [motivoRechazo, setMotivoRechazo] = useState("");
  const [motivoError, setMotivoError] = useState("");
  const [listCostos, setListCostos] = useState([]);
  const [listCondiciones, setListCondiciones] = useState([]);
  const [showEditPresupuestoModal, setShowEditPresupuestoModal] = useState(false);
  const [editedPresupuesto, setEditedPresupuesto] = useState({});
  const [condiciones, setCondiciones] = useState([]);
  const [items, setItems] = useState([]);
  const [presupuesto, setPresupuesto] = useState();
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [newEstado, setNewEstado] = useState("");
  const [showItemModal, setShowItemModal] = useState(false);
  const [showCondicionModal, setShowCondicionModal] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [currentCondicion, setCurrentCondicion] = useState(null);
  const [cantidadValid, setCantidadValid] = useState(true);
  const [descuentoValid, setDescuentoValid] = useState(true);
  const [averagePriceValid, setAveragePriceValid] = useState(true);
  const [buttonLoading, setButtonLoading] = useState({
    changeEstado: false,
    updateItem: false,
    updateCondicion: false,
    updatePresupuesto: false,
    addItem: false,
    addCondicion: false,
    deleteItem: false,
    deleteCondicion: false,
    generatePDF: false,
  });
  const { id } = useParams();

  const statusColors = {
    CREADO: "black",
    ENVIADO: "blue",
    "EN NEGOCIACIÓN": "orange",
    "SIN RESPUESTA": "gray",
    APROBADO: "green",
    RECHAZADO: "red",
  };

  const isApproved = presupuesto?.estado === "APROBADO";

  const setActionLoading = (action, value) => {
    setButtonLoading((prev) => ({ ...prev, [action]: value }));
  };


  const assignValue = useCallback(async () => {
    try {
      const presupuestoResult = await getPresupuestoById(id);
      setCondiciones(presupuestoResult.condiciones);
      setItems(presupuestoResult.items);
      setPresupuesto(presupuestoResult.presupuesto);

      const costosResult = await getAllCostos();
      const mapeoCostos = costosResult.map((item) => ({
        value: item.idcostos,
        label: `${item.COD} ${item.producto}`,
        COD: item.COD,
        precioventa: item.precioventa,
      }));
      setListCostos(mapeoCostos);

      const condicionesResult = await getAllCondiciones();
      const mapeoCondiciones = condicionesResult.result.map((item) => ({
        value: item.cod,
        label: item.cod,
        cod: item.cod,
        condicion: item.condicion,
      }));
      setListCondiciones(mapeoCondiciones);

      setLoading(false);
    } catch (err) {
      console.error("Error fetching data:", err);
      alert("Error al cargar los datos. Por favor, intenta de nuevo.");
      setLoading(false);
    }
  }, [id]);

  const handleChangeEstado = async () => {
    if (isApproved || !newEstado) return;

    const isRechazado = String(newEstado).toUpperCase().trim() === "RECHAZADO";
    const motivoClean = isRechazado ? String(motivoRechazo ?? "").trim().slice(0, 200) : null;

    if (isRechazado && !motivoClean) {
      setMotivoError("Debe ingresar un motivo de rechazo (máx. 200 caracteres).");
      return;
    }

    setActionLoading("changeEstado", true);
    try {
      await updateEstadoPresupuesto(id, newEstado, motivoClean);
      setPresupuesto((prev) => ({
        ...prev,
        estado: newEstado,
        ...(isRechazado ? { motivorechazo: motivoClean } : { motivorechazo: null })
      }));
      setShowModal(false);
      setNewEstado("");
      setMotivoRechazo("");
      setMotivoError("");
    } catch (err) {
      console.error("Error updating status:", err);
      alert("Error al actualizar el estado. Por favor, intenta de nuevo.");
    } finally {
      setActionLoading("changeEstado", false);
    }
  };
  const handleGeneratePDF = async (tipo) => {
    setPdfTipo(tipo); // nuevo
    setActionLoading("generatePDF", true);

    const blob = await pdf(
      <CombinedPDF
        tipo={tipo}
        presupuesto={presupuesto}
        items={items}
        condiciones={condiciones}
        subtotal={subtotalGlobal}
        total={totalGlobal}
        descuento={descuentoGlobal}
      />
    ).toBlob();

    const url = URL.createObjectURL(blob);
    setPdfReady(url);
    setActionLoading("generatePDF", false);
  };

  const handleEditItem = (item) => {
    if (isApproved) return;
    setCurrentItem(item);
    setShowItemModal(true);
    setCantidadValid(true);
    setDescuentoValid(true);
    setAveragePriceValid(true);
  };
  const handleEditCondicion = (condicion) => {
    if (isApproved) return;
    setCurrentCondicion(condicion);
    setShowCondicionModal(true);
  };
  const handleSelectChange = (selectedOption) => {
    if (isApproved) return;
    const cantidad = currentItem?.cantidad || 1; // Default to 1 if no quantity
    const descuento = Math.min(currentItem?.descuento || 0, 100); // Cap discount at 100
    const precio = selectedOption?.precioventa || 0;
    const subtotal = cantidad * precio;
    const total = subtotal * (1 - descuento / 100);
    const averagePrice = cantidad ? total / cantidad : 0;

    setCurrentItem((prev) => ({
      ...prev,
      codigo: selectedOption?.COD || "",
      descripcion: selectedOption?.label.split(' ').slice(1).join(' ') || "",
      precio,
      subtotal,
      total,
      averagePrice,
      descuento, // Ensure discount is capped
    }));
    setDescuentoValid(descuento <= 100);
  };
  const handleCondicionChange = (selectedOption) => {
    if (isApproved) return;
    setCurrentCondicion((prev) => ({
      ...prev,
      condiciones: selectedOption?.condicion || "",
    }));
  };

  const handleUpdateItem = async (e) => {
    e.preventDefault();
    if (!cantidadValid || !descuentoValid || !averagePriceValid || isApproved) return;
    setActionLoading("updateItem", true);
    try {
      await updateItemPresupuesto(currentItem.idpresupuestos, currentItem.iditempresupuesto, {
        codigo: currentItem.codigo,
        descripcion: currentItem.descripcion,
        cantidad: currentItem.cantidad,
        precio: currentItem.precio,
        descuento: currentItem.descuento,
        subtotal: currentItem.subtotal,
        total: currentItem.total,
        averagePrice: currentItem.averagePrice,
      });
      await assignValue();
      setShowItemModal(false);
      setCurrentItem(null);
      setCantidadValid(true);
      setDescuentoValid(true);
      setAveragePriceValid(true);
    } catch (err) {
      console.error("Error updating item:", err);
      alert("Error al actualizar el ítem. Por favor, intenta de nuevo.");
    } finally {
      setActionLoading("updateItem", false);
    }
  };

  const handleUpdateCondicion = async (e) => {
    e.preventDefault();
    if (isApproved) return;
    setActionLoading("updateCondicion", true);
    try {
      await updateCondicionesPresupuesto(currentCondicion.idpresupuestos, currentCondicion.idcondicionespresupuesto, {
        condiciones: currentCondicion.condiciones,
      });
      await assignValue();
      setShowCondicionModal(false);
      setCurrentCondicion(null);
    } catch (err) {
      console.error("Error updating condicion:", err);
      alert("Error al actualizar la condición. Por favor, intenta de nuevo.");
    } finally {
      setActionLoading("updateCondicion", false);
    }
  };

  const handleUpdatePresupuesto = async () => {
    if (isApproved) return;
    setActionLoading("updatePresupuesto", true);
    try {
      const updated = {
        asesor: editedPresupuesto.asesor,
        nombre_cliente: editedPresupuesto.nombre_cliente,
        correo_cliente: editedPresupuesto.correo_cliente,
        direccion_cliente: editedPresupuesto.direccion_cliente,
        ciudad_cliente: editedPresupuesto.ciudad_cliente,
        telefono_cliente: editedPresupuesto.telefono_cliente,
        validohasta: editedPresupuesto.validohasta,
        obs: editedPresupuesto.obs,
        averagePrice: editedPresupuesto.averagePrice,
        idcliente: presupuesto.idcliente,
      };
      await updatePresupuesto(id, updated);
      await assignValue();
      setShowEditPresupuestoModal(false);
    } catch (err) {
      console.error("Error al actualizar datos del presupuesto:", err.message);
      alert("Error al actualizar los datos del presupuesto. Por favor, intenta de nuevo.");
    } finally {
      setActionLoading("updatePresupuesto", false);
    }
  };

  const handleAddItem = async (idpresupuestos) => {
    if (isApproved) return;
    setActionLoading("addItem", true);
    try {
      const nuevoItem = {
        idpresupuestos,
        codigo: "NUEVO",
        descripcion: "Descripción",
        cantidad: 1,
        precio: 0,
        subtotal: 0,
        descuento: 0,
        total: 0,
        averagePrice: 0,
      };
      await insertItemPresupuesto(nuevoItem);
      await assignValue();
    } catch (err) {
      console.error("Error al agregar ítem:", err.message);
      alert("Error al agregar el ítem. Por favor, intenta de nuevo.");
    } finally {
      setActionLoading("addItem", false);
    }
  };

  const handleAddCondicion = async (idpresupuestos) => {
    if (isApproved) return;
    setActionLoading("addCondicion", true);
    try {
      const nuevaCondicion = {
        idpresupuestos,
        condiciones: "Nueva condición",
      };
      await insertCondicionesPresupuesto(nuevaCondicion);
      await assignValue();
    } catch (err) {
      console.error("Error al agregar condición:", err.message);
      alert("Error al agregar la condición. Por favor, intenta de nuevo.");
    } finally {
      setActionLoading("addCondicion", false);
    }
  };

  const handleDeleteItem = async (iditempresupuesto) => {
    if (isApproved) return;
    setActionLoading("deleteItem", true);
    try {
      await deleteItemPresupuesto(iditempresupuesto);
      await assignValue();
    } catch (err) {
      console.error("Error al eliminar ítem:", err.message);
      alert("Error al eliminar el ítem. Por favor, intenta de nuevo.");
    } finally {
      setActionLoading("deleteItem", false);
    }
  };

  const handleDeleteCondicion = async (idcondicionespresupuesto) => {
    if (isApproved) return;
    setActionLoading("deleteCondicion", true);
    try {
      await deleteConPresupuesto(idcondicionespresupuesto);
      await assignValue();
    } catch (err) {
      console.error("Error al eliminar condición:", err.message);
      alert("Error al eliminar la condición. Por favor, intenta de nuevo.");
    } finally {
      setActionLoading("deleteCondicion", false);
    }
  };

  useEffect(() => {
    assignValue();
  }, [assignValue]);
  useEffect(() => {
    if (pdfReady && presupuesto) {
      const clienteLimpio = (presupuesto.nombre_cliente || "")
        .replace(/[^a-zA-Z0-9_ÁÉÍÓÚÑáéíóúñ ]/g, "")
        .replace(/\s+/g, "_");

      const tipoNombre =
        pdfTipo === "enfermeria"
          ? "Enfermeria"
          : pdfTipo === "cuidador"
            ? "Cuidador"
            : "Documento";

      const nombreArchivo = `Cotizacion_${presupuesto.idpresupuestos}_${tipoNombre}_${clienteLimpio}.pdf`;

      const link = document.createElement("a");
      link.href = pdfReady;
      link.download = nombreArchivo;
      link.click();
    }
  }, [pdfReady, presupuesto, pdfTipo]);

  const subtotalGlobal = items.reduce((acc, item) => acc + (item.subtotal || 0), 0);
  const totalGlobal = items.reduce((acc, item) => acc + (item.total || 0), 0);
  const descuentoGlobal = subtotalGlobal - totalGlobal;

  return (
    <Col lg={12}>
      {loading ? (
        <div className="d-flex justify-content-center">
          <TailSpin
            height="80"
            width="80"
            color="black"
            ariaLabel="tail-spin-loading"
            radius="1"
            wrapperStyle={{}}
            wrapperClass=""
            visible={loading}
          />
        </div>
      ) : (
        <Card>
          <Card.Header className="d-flex justify-content-between align-items-center">
            <Card.Title>
              <div className="me-3">
                <h2>Detalles del Presupuesto</h2>
                <span className="fs-4" style={{ color: statusColors[presupuesto.estado] || "black" }}>
                  Estado: {presupuesto.estado}
                </span>
              </div>
            </Card.Title>

            <div className="d-flex align-items-center gap-2">
              <Button
                variant="primary"
                size="sm"
                onClick={() => handleGeneratePDF("enfermeria")}
                disabled={buttonLoading.generatePDF}
              >
                {buttonLoading.generatePDF ? "Generando..." : "PDF Enfermería"}
              </Button>

              <Button
                variant="primary"
                size="sm"
                onClick={() => handleGeneratePDF("cuidador")}
                disabled={buttonLoading.generatePDF}
              >
                {buttonLoading.generatePDF ? "Generando..." : "PDF Cuidador"}
              </Button>
              <Button
                variant="primary"
                size="sm"
                onClick={() => handleGeneratePDF("solo")}
                disabled={buttonLoading.generatePDF}
              >
                {buttonLoading.generatePDF ? "Generando..." : "Solo Presupuesto"}
              </Button>




              {/* Dropdown */}
              <Dropdown>
                <Dropdown.Toggle variant="primary" id="dropdown-options" size="sm">
                  Opciones
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  <Dropdown.Item
                    onClick={() => {
                      if (!isApproved) {
                        setEditedPresupuesto(presupuesto);
                        setShowEditPresupuestoModal(true);
                      }
                    }}
                    disabled={isApproved}
                  >
                    Editar Datos
                  </Dropdown.Item>

                  <Dropdown.Item
                    onClick={() => {
                      if (!isApproved) {
                        setMotivoRechazo("");
                        setMotivoError("");
                        setNewEstado("");
                        setShowModal(true);
                      }
                    }}
                    disabled={isApproved}
                  >
                    Cambiar Estado
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Card.Header>

          <Card.Body>
            <Row>
              <Col md={4}>
                <h3>Cliente</h3>
                <div className="fs-5">
                  <p><strong>Cliente:</strong> {presupuesto.nombre_cliente}</p>
                  <p><strong>Correo:</strong> {presupuesto.correo_cliente}</p>
                  <p><strong>Dirección:</strong> {presupuesto.direccion_cliente}</p>
                  <p><strong>Ciudad:</strong> {presupuesto.ciudad_cliente}</p>
                  <p><strong>Teléfono:</strong> {presupuesto.telefono_cliente}</p>
                </div>
              </Col>
              <Col md={4}>
                <h3>Observaciones</h3>
                <div
                  className="fs-5 p-3 rounded border"
                  style={{
                    backgroundColor: "#fff3cd", // leve amarillo tipo alerta
                    color: "#dc3545",           // rojo Bootstrap "danger"
                    fontWeight: "bold",
                    borderColor: "#ffeeba",     // borde más tenue
                    whiteSpace: "pre-wrap",
                    minHeight: 160,
                  }}
                >
                  {presupuesto.obs ? presupuesto.obs : <em style={{ fontWeight: "normal", color: "#d41009ff" }}>Sin observaciones.</em>}
                </div>



                {presupuesto?.estado === "RECHAZADO" && presupuesto?.motivorechazo && (
                  <div className="alert alert-danger mt-3 mb-0">
                    <strong>Motivo de rechazo:</strong> {presupuesto.motivorechazo}
                  </div>
                )}
              </Col>

              <Col md={4}>
                <h3>Cotización</h3>
                <div className="fs-5">
                  <p><strong>Fecha:</strong> {presupuesto.fecha}</p>
                  <p><strong>Cotización #:</strong> {presupuesto.idpresupuestos}</p>
                  <p><strong>Válido hasta:</strong> {presupuesto.validohasta}</p>
                  <p><strong>Asesor:</strong> {presupuesto.asesor}</p>
                </div>
              </Col>
            </Row>
            <h3 className="mt-4 d-flex justify-content-between align-items-center">
              Ítems
              <Button
                variant="success"
                size="sm"
                onClick={() => handleAddItem(presupuesto.idpresupuestos)}
                disabled={buttonLoading.addItem || isApproved}
              >
                {buttonLoading.addItem ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Agregando...
                  </>
                ) : (
                  "+ Agregar Ítem"
                )}
              </Button>
            </h3>
            <Table striped bordered responsive>
              <thead>
                <tr>
                  <th style={{ width: "9%" }}>Código</th>
                  <th style={{ width: "42%" }}>Descripción</th>
                  <th style={{ width: "5%" }}>Cant.</th>
                  <th style={{ width: "12%" }}>Precio</th>
                  <th style={{ width: "13%" }}>Subtotal</th>
                  <th style={{ width: "5%" }}>Desc.</th>
                  <th style={{ width: "11%" }}>Total</th>
                  <th style={{ width: "18%" }}>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {items.length > 0 ? (
                  items.map((item) => (
                    <tr key={item.iditempresupuesto}>
                      <td>{item.codigo}</td>
                      <td style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{item.descripcion}</td>
                      <td>{item.cantidad}</td>
                      <td>{item.precio.toLocaleString()} Gs.</td>
                      <td>{item.subtotal.toLocaleString()} Gs.</td>
                      <td>{item.descuento}%</td>
                      <td>{item.total.toLocaleString()} Gs.</td>
                      <td>
                        <Button
                          variant="warning"
                          size="sm"
                          className="me-2"
                          onClick={() => handleEditItem(item)}
                          disabled={isApproved}
                        >
                          Editar
                        </Button>
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => handleDeleteItem(item.iditempresupuesto)}
                          disabled={buttonLoading.deleteItem || isApproved}
                        >
                          {buttonLoading.deleteItem ? (
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                            />
                          ) : (
                            <i className="bi bi-trash"></i>
                          )}
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={9} className="text-center">
                      No hay datos disponibles
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            {!loading && presupuesto?.averagePrice && (
              <h4 className="mt-3">
                <strong>Tarifa de servicio para enfermería por hora Gs. {presupuesto.averagePrice.toLocaleString()}</strong>
              </h4>
            )}
            <h3 className="d-flex justify-content-between align-items-center">
              Condiciones
              <Button
                variant="success"
                size="sm"
                onClick={() => handleAddCondicion(presupuesto.idpresupuestos)}
                disabled={buttonLoading.addCondicion || isApproved}
              >
                {buttonLoading.addCondicion ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Agregando...
                  </>
                ) : (
                  "+ Agregar Condición"
                )}
              </Button>
            </h3>
            <Table striped bordered responsive>
              <thead>
                <tr>
                  <th>Condición</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {condiciones.length > 0 ? (
                  condiciones.map((item) => (
                    <tr key={item.idcondicionespresupuesto}>
                      <td
                        style={{
                          width: "85%",
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                        }}
                        dangerouslySetInnerHTML={{ __html: item.condiciones }}
                      />
                      <td>
                        <Button
                          variant="warning"
                          size="sm"
                          className="me-2"
                          onClick={() => handleEditCondicion(item)}
                          disabled={isApproved}
                        >
                          Editar
                        </Button>
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => handleDeleteCondicion(item.idcondicionespresupuesto)}
                          disabled={buttonLoading.deleteCondicion || isApproved}
                        >
                          {buttonLoading.deleteCondicion ? (
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                            />
                          ) : (
                            <i className="bi bi-trash"></i>
                          )}
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={2} className="text-center">
                      No hay datos disponibles
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <hr className="my-4" />
            <Row className="mb-4 justify-content-center">
              <Col md={5} className="mb-3">
                <Card className="text-center shadow-sm border-primary">
                  <Card.Body>
                    <Card.Title className="text-primary">Subtotal</Card.Title>
                    <Card.Text className="display-6 fw-bold text-primary">
                      {subtotalGlobal.toLocaleString()} Gs.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col mt={5} className="mb-3">
                <Card className="text-center shadow-sm border-success">
                  <Card.Body>
                    <Card.Title className="text-success">Total</Card.Title>
                    <Card.Text className="display-6 fw-bold text-success">
                      {totalGlobal.toLocaleString()} Gs.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={5} className="mb-3">
                <Card className="text-center shadow-sm border-danger">
                  <Card.Body>
                    <Card.Title className="text-danger">Descuento</Card.Title>
                    <Card.Text className="display-6 fw-bold text-danger">
                      {descuentoGlobal.toLocaleString()} Gs.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      )}
      <Modal show={showModal} onHide={() => { setShowModal(false); setMotivoRechazo(""); setMotivoError(""); }}>
        <Modal.Header closeButton>
          <Modal.Title>Cambiar Estado del Presupuesto</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form className="d-flex justify-content-center">
            <div className="mx-auto w-100" style={{ maxWidth: 480, minWidth: 0 }}>
              <Form.Group className="mb-3 text-center" style={{ minWidth: 0 }}>
                <Form.Label className="w-100">Seleccionar Nuevo Estado</Form.Label>
                <Form.Select
                  className="w-100"
                  style={{ minWidth: 0, boxSizing: "border-box" }}
                  value={newEstado}
                  onChange={(e) => {
                    const v = e.target.value;
                    setNewEstado(v);
                    if (String(v).toUpperCase() === "RECHAZADO" && !motivoRechazo.trim()) {
                      setMotivoError("Debe ingresar un motivo de rechazo (máx. 200 caracteres).");
                    } else {
                      setMotivoError("");
                    }
                  }}
                  disabled={isApproved}
                >
                  <option value="">Seleccione un estado</option>
                  {Object.keys(statusColors).map((estado) => (
                    <option key={estado} value={estado}>{estado}</option>
                  ))}
                </Form.Select>
              </Form.Group>

              {String(newEstado).toUpperCase() === "RECHAZADO" && (
                <Form.Group className="mt-3" style={{ minWidth: 0 }}>
                  <Form.Label className="w-100 text-center">Motivo de rechazo</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    maxLength={200}
                    value={motivoRechazo}

                    onChange={(e) => {
                      const v = e.target.value.slice(0, 200);
                      setMotivoRechazo(v);
                      setMotivoError(v.trim() ? "" : "Debe ingresar un motivo de rechazo (máx. 200 caracteres).");
                    }}
                    placeholder="Describa brevemente el motivo del rechazo (máx. 200 caracteres)"
                    disabled={isApproved}
                  />
                  <div className="d-flex flex-column align-items-center mt-2">
                    <Form.Control.Feedback type="invalid" className="d-block text-center">
                      {motivoError}
                    </Form.Control.Feedback>
                    <small className="text-muted">{motivoRechazo.length}/200</small>
                  </div>
                </Form.Group>
              )}
            </div>
          </Form>



        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={handleChangeEstado}
            disabled={
              !newEstado ||
              buttonLoading.changeEstado ||
              isApproved ||
              (String(newEstado).toUpperCase() === "RECHAZADO" && !motivoRechazo.trim())
            }
          >

            {buttonLoading.changeEstado ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Guardando...
              </>
            ) : (
              "Guardar Cambios"
            )}
          </Button>
          <Button
            variant="danger"
            onClick={() => setShowModal(false)}
            className="ms-2"
          >
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showItemModal} onHide={() => setShowItemModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Editar Ítem</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleUpdateItem}>
            <Form.Group className="mb-3">
              <Form.Label>Código</Form.Label>
              <Form.Control
                type="text"
                value={currentItem?.codigo || ""}
                onChange={(e) =>
                  setCurrentItem((prev) => ({ ...prev, codigo: e.target.value }))
                }
                disabled={true}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Descripción</Form.Label>
              <Select
                className="mt-2"
                options={listCostos}
                name="descripcion"
                value={listCostos.find((option) => option.label.split(' ').slice(1).join(' ') === currentItem?.descripcion && option.COD === currentItem?.codigo) || null}
                onChange={handleSelectChange}
                placeholder="Seleccione una descripción"
                styles={customSelectStyles}
                menuPortalTarget={document.body}
                isDisabled={isApproved}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Cantidad</Form.Label>
              <Form.Control
                type="number"
                min="1"
                value={currentItem?.cantidad || ""}
                isInvalid={!cantidadValid}
                onChange={(e) => {
                  const value = parseInt(e.target.value);
                  const isValid = value >= 1;
                  setCantidadValid(isValid);
                  if (isValid) {
                    setCurrentItem((prev) => ({
                      ...prev,
                      cantidad: value,
                      subtotal: value * (prev?.precio || 0),
                      total: value * (prev?.precio || 0) * (1 - (Math.min(prev?.descuento || 0, 100) / 100)),
                      averagePrice: value ? (value * (prev?.precio || 0) * (1 - (Math.min(prev?.descuento || 0, 100) / 100))) / value : 0,
                    }));
                  }
                }}
                disabled={isApproved}
              />
              <Form.Control.Feedback type="invalid">
                La cantidad debe ser mayor a 0.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Precio</Form.Label>
              <Form.Control
                type="number"
                min="0"
                value={currentItem?.precio || ""}
                onChange={(e) => {
                  const value = parseFloat(e.target.value);
                  setCurrentItem((prev) => ({
                    ...prev,
                    precio: value >= 0 ? value : 0,
                    subtotal: (prev?.cantidad || 0) * (value >= 0 ? value : 0),
                    total: (prev?.cantidad || 0) * (value >= 0 ? value : 0) * (1 - (Math.min(prev?.descuento || 0, 100) / 100)),
                    averagePrice: (prev?.cantidad || 0) ? ((prev?.cantidad || 0) * (value >= 0 ? value : 0) * (1 - (Math.min(prev?.descuento || 0, 100) / 100))) / (prev?.cantidad || 0) : 0,
                  }));
                }}
                disabled={true}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Descuento (%)</Form.Label>
              <Form.Control
                type="number"
                min="0"
                max="100"
                value={currentItem?.descuento}
                isInvalid={!descuentoValid}
                onChange={(e) => {
                  const value = parseFloat(e.target.value);
                  const isValid = value >= 0 && value <= 100;
                  setDescuentoValid(isValid);
                  if (isValid) {
                    setCurrentItem((prev) => ({
                      ...prev,
                      descuento: value,
                      total: (prev?.subtotal || 0) * (1 - value / 100),
                      averagePrice: (prev?.cantidad || 0) ? ((prev?.subtotal || 0) * (1 - value / 100)) / (prev?.cantidad || 0) : 0,
                    }));
                  }
                }}
                disabled={isApproved}
              />
              <Form.Control.Feedback type="invalid">
                El descuento debe estar entre 0 y 100.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Subtotal</Form.Label>
              <Form.Control
                type="text"
                value={currentItem?.subtotal?.toLocaleString() + " Gs." || "0 Gs."}
                disabled
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Total</Form.Label>
              <Form.Control
                type="text"
                value={currentItem?.total?.toLocaleString() + " Gs." || "0 Gs."}
                disabled
              />
            </Form.Group>
            <Button
              variant="primary"
              type="submit"
              disabled={!currentItem || !cantidadValid || !descuentoValid || !averagePriceValid || buttonLoading.updateItem || isApproved}
            >
              {buttonLoading.updateItem ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Guardando...
                </>
              ) : (
                "Guardar Cambios"
              )}
            </Button>
            <Button
              variant="danger"
              onClick={() => {
                setShowItemModal(false);
                setCantidadValid(true);
                setDescuentoValid(true);
                setAveragePriceValid(true);
              }}
              className="ms-2"
            >
              Cancelar
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal show={showCondicionModal} onHide={() => setShowCondicionModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Editar Condición</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleUpdateCondicion}>
            <Form.Group className="mb-3">
              <Form.Label>Condición</Form.Label>
              <Select
                className="mt-2 me-2"
                options={listCondiciones}
                value={
                  listCondiciones.find(
                    (option) => option.condicion === currentCondicion?.condiciones
                  ) || null
                }
                onChange={handleCondicionChange}
                placeholder="Seleccione una condición"
                styles={customSelectStyles}
                menuPortalTarget={document.body}
                isDisabled={isApproved}
                formatOptionLabel={(option) => (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span style={{ fontWeight: "bold" }}>{option.cod}</span>
                    <span
                      style={{ whiteSpace: "normal" }}
                      dangerouslySetInnerHTML={{ __html: option.condicion }}
                    />
                  </div>
                )}
              />
            </Form.Group>
            <Button
              variant="primary"
              type="submit"
              disabled={!currentCondicion || buttonLoading.updateCondicion || isApproved}
            >
              {buttonLoading.updateCondicion ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Guardando...
                </>
              ) : (
                "Guardar Cambios"
              )}
            </Button>
            <Button
              variant="danger"
              onClick={() => setShowCondicionModal(false)}
              className="ms-2"
            >
              Cancelar
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal show={showEditPresupuestoModal} onHide={() => setShowEditPresupuestoModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Editar Datos del Presupuesto</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Asesor</Form.Label>
              <Form.Control
                type="text"
                value={editedPresupuesto?.asesor || ""}
                onChange={(e) =>
                  setEditedPresupuesto((prev) => ({ ...prev, asesor: e.target.value }))
                }
                disabled={isApproved}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Cliente</Form.Label>
              <Form.Control
                type="text"
                value={editedPresupuesto?.nombre_cliente || ""}
                onChange={(e) =>
                  setEditedPresupuesto((prev) => ({ ...prev, nombre_cliente: e.target.value }))
                }
                disabled={isApproved}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Correo</Form.Label>
              <Form.Control
                type="email"
                value={editedPresupuesto?.correo_cliente || ""}
                onChange={(e) =>
                  setEditedPresupuesto((prev) => ({ ...prev, correo_cliente: e.target.value }))
                }
                disabled={isApproved}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Dirección</Form.Label>
              <Form.Control
                type="text"
                value={editedPresupuesto?.direccion_cliente || ""}
                onChange={(e) =>
                  setEditedPresupuesto((prev) => ({ ...prev, direccion_cliente: e.target.value }))
                }
                disabled={isApproved}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Ciudad</Form.Label>
              <Form.Control
                type="text"
                value={editedPresupuesto?.ciudad_cliente || ""}
                onChange={(e) =>
                  setEditedPresupuesto((prev) => ({ ...prev, ciudad_cliente: e.target.value }))
                }
                disabled={isApproved}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Teléfono</Form.Label>
              <Form.Control
                type="text"
                value={editedPresupuesto?.telefono_cliente || ""}
                onChange={(e) =>
                  setEditedPresupuesto((prev) => ({ ...prev, telefono_cliente: e.target.value }))
                }
                disabled={isApproved}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Válido hasta</Form.Label>
              <Form.Control
                type="date"
                value={editedPresupuesto?.validohasta?.split("T")[0] || ""}
                onChange={(e) =>
                  setEditedPresupuesto((prev) => ({ ...prev, validohasta: e.target.value }))
                }
                disabled={isApproved}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Precio Enfermeria por Hora</Form.Label>
              <Form.Control
                type="number"
                min="0"
                value={editedPresupuesto?.averagePrice || ""}
                isInvalid={!averagePriceValid}
                onChange={(e) => {
                  const value = parseFloat(e.target.value);
                  const isValid = value >= 0;
                  setAveragePriceValid(isValid);
                  if (isValid) {
                    setEditedPresupuesto((prev) => ({ ...prev, averagePrice: value }));
                  }
                }}
                disabled={isApproved}
              />
              <Form.Control.Feedback type="invalid">
                El precio promedio no puede ser negativo.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Observaciones</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={editedPresupuesto?.obs || ""}
                onChange={(e) =>
                  setEditedPresupuesto((prev) => ({ ...prev, obs: e.target.value }))
                }
                disabled={isApproved}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={handleUpdatePresupuesto}
            disabled={buttonLoading.updatePresupuesto || !averagePriceValid || isApproved}
          >
            {buttonLoading.updatePresupuesto ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Guardando...
              </>
            ) : (
              "Guardar Cambios"
            )}
          </Button>
          <Button
            variant="danger"
            onClick={() => setShowEditPresupuestoModal(false)}
          >
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>


    </Col>
  );
};

export default FichaPresupuesto;